import { DateTime } from "../fundamental/DateTime";
import { UserId } from "../user/UserId";
import { OperationContent } from "./OperationContent";
import { OperationTarget, getOperationTargetFromValue } from "./OperationTarget";
import { OperationType, getOperationTypeFromValue } from "./OperationType";

const AdminOperationLogType = Symbol();

export class AdminOperationLog {
    [AdminOperationLogType]: any;
    readonly userId: UserId;
    readonly operationTarget: OperationTarget;
    readonly operationType: OperationType;
    readonly operationContentBefore: OperationContent;
    readonly operationContentAfter: OperationContent;
    readonly operationTime: DateTime;

    private constructor(
        userId: UserId,
        operationTarget: OperationTarget,
        operationType: OperationType,
        operationContentBefore: OperationContent,
        operationContentAfter: OperationContent,
        operationTime: DateTime
    ) {
        this.userId = userId;
        this.operationTarget = operationTarget;
        this.operationType = operationType;
        this.operationContentBefore = operationContentBefore;
        this.operationContentAfter = operationContentAfter;
        this.operationTime = operationTime;
    }

    static from(
        userId: UserId,
        operationTarget: OperationTarget,
        operationType: OperationType,
        operationContentBefore: OperationContent,
        operationContentAfter: OperationContent,
        operationTime: DateTime
    ): AdminOperationLog {
        return new AdminOperationLog(userId, operationTarget, operationType, operationContentBefore, operationContentAfter, operationTime);
    }

    static fromJson(jsonData: AdminOperationLogJson) {
        return this.from(
            UserId.fromString(jsonData.userId),
            getOperationTargetFromValue(jsonData.operationTarget),
            getOperationTypeFromValue(jsonData.operationType),
            OperationContent.fromString(jsonData.operationContentBefore),
            OperationContent.fromString(jsonData.operationContentAfter),
            DateTime.fromString(jsonData.operationTime)
        );
    }
}

export type AdminOperationLogJson = {
    userId: string,
    operationTarget: string,
    operationType: string,
    operationContentBefore: string,
    operationContentAfter: string,
    operationTime: string
};
